package com.eladfinish.bible.contest.screens.search.usecases.searchSuggestion

import dev.icerock.moko.resources.desc.StringDesc

data class SearchSuggestionUiModel(
    val message: StringDesc,
    val suggestedExpression: String,
)
